const guideAndReportsItems = [
  {
    image: 'GuidesAndReports/01.png',
    category: 'Report',
    title: `The Business Case for MarTech Consolidation`,
    shortDescription: `Your marketing technology stack is costing you millions in hidden expenses while...`,
    url: 'the-business-case-for-martech-consolidation',
    heroTitle: 'The Business Case for MarTech Consolidation',
    heroDescription: `Stop Burning $400,000+ on Marketing Technology That Doesn't Work`,
    content: `<p>Your marketing technology stack is costing you millions in hidden expenses while delivering diminishing returns. Despite investing in 120+ marketing solutions, utilization has crashed to just 33% while integration costs spiral out of control.</p>
              <p>This executive white paper reveals the shocking financial reality of martech proliferation and provides a data-driven business case for strategic consolidation. Discover how industry leaders like Lendlease achieved 78% cost reductions and TMF Group delivered 2,101% ROI through unified platform strategies.</p>
<p>Download the white paper now to discover why martech consolidation isn't just a trend—it's a strategic imperative for profitable growth:</p>
<ul>
<li>The real cost of your fragmented martech stack (beyond licensing fees)</li>
<li>Proven ROI data from successful consolidation projects</li>
<li>Why 84% of buyers now prefer single solutions over multiple tools</li>
<li>Strategic recommendations for immediate cost reduction opportunities</li>
<li>How unified platforms deliver 6x lower total cost of ownership</li>
</ul>`,
    idForm: 'DownloadtheWhitePaper/formperma/9aLPQoTWak8qbalGmBIUMA5yNbh97dMWiCCV1kIzKXU',
  },
  {
    image: 'GuidesAndReports/02.png',
    category: 'Guide',
    title: `The Technical Case for Unified Platforms`,
    shortDescription: `Your engineering team spends 40-60% of their time maintaining fragmented...`,
    url: 'the-technical-case-for-unified-platforms',
    heroTitle: 'The Technical Case for Unified Platforms',
    heroDescription: `Solve the Integration Nightmare That's Killing Your Marketing Performance`,
    content: `
<p>Your engineering team spends 40-60% of their time maintaining fragmented marketing integrations instead of building innovative features. With 65.7% of organizations citing data integration as their biggest challenge, the technical evidence overwhelmingly favors unified platform architectures.</p>

<p>This technical white paper provides the engineering perspective on why best-of-breed martech stacks create exponential complexity while unified platforms deliver superior performance, reliability, and scalability.</p>
<p>Download the white paper now to discover how unified platforms eliminate technical complexity while enabling advanced AI and real-time personalization capabilities:</p>
<ul>
<li>Why API management becomes exponentially complex with vendor count</li>
<li>Performance benchmarks: 2-3 hour data delays vs. 30-second unified processing</li>
<li>Technical debt analysis: How fragmentation consumes 20-40% of IT budgets</li>
<li>Security and compliance advantages of unified architectures</li>
<li>Migration strategies that minimize risk while maximizing performance gains</li>
</ul>
    `,
    idForm: 'DownloadtheGuideTheTechnicalCaseforUnifiedPlatform/formperma/dcAn8vRRWMVJYDiUuMEn7QoZAISPy-vKEptWIcgVAHY',
  },
  {
    image: 'GuidesAndReports/03.png',
    category: 'Report',
    title: `Benchmark Report 2025`,
    shortDescription: `Download our 2024 global benchmark report by industry, packed with expert...`,
    url: 'the-benchmark-report',
    heroTitle: 'Releva 2024 Benchmark Report',
    heroDescription: `Is Your Email Marketing Underperforming? Get the Real Numbers from 2024`,
    content: `
<p>YStop guessing whether your email campaigns are hitting the mark. This comprehensive 2024 benchmark report reveals the actual performance metrics from thousands of successful e-commerce businesses using AI-powered personalization, giving you the data you need to measure your success.</p>

<p>Based on real transactions from millions of customer interactions across diverse industries, this report exposes the performance gaps between traditional email marketing and AI-driven personalization strategies. Discover why some businesses achieve 59.7% open rates while others struggle with industry averages.</p>
<p>Download the report now to discover where your email marketing stands against top performers and get the proven strategies to join the high-achievers delivering exceptional results:</p>
<ul>
<li>Real performance benchmarks: Open rates, click rates, conversion rates, and unsubscribe rates from successful businesses</li>
<li>Industry comparison data from companies like Releva, Klaviyo, and Omnisend</li>
<li>Proven strategies that drive 6x higher engagement rates through personalized recommendations</li>
<li>Step-by-step guidance for optimizing customer segmentation and message timing</li>
<li>Advanced techniques for transforming email clicks into loyal, repeat customers</li>
<li>Solutions to overcome common challenges like message fatigue and poor conversion rates</li>
    </ul>
    `,
    idForm: 'IndustriesBenchmarkReportReleva2024/formperma/Pu-6CGF3KISptB2zjf3YM6P8ClgEkIIuAepuJvyHVvA',
  },
  {
    image: 'GuidesAndReports/04.png',
    category: 'Guide',
    title: `The Path Forward - Strategic Implementation Guide`,
    shortDescription: `You know consolidation makes business sense, but how do you actually execute...`,
    url: 'the-path-forward',
    heroTitle: 'The Path Forward - Strategic Implementation Guide',
    heroDescription: `Your Step-by-Step Roadmap to Successful MarTech Consolidation`,
    content: `
<p>You know consolidation makes business sense, but how do you actually execute it without disrupting operations or losing critical capabilities? This strategic implementation guide provides a proven framework used by organizations achieving 70-80% cost reductions within 24 months.</p>

<p>Based on successful consolidations across multiple industries, this white paper delivers practical guidance for transforming your fragmented martech stack into a unified growth engine.</p>
<p>Download the guide now to  to get the proven playbook for transforming marketing technology chaos into competitive advantage:</p>
<ul>
<li>4-phase implementation framework with clear timelines and milestones</li>
<li>Platform selection criteria and vendor evaluation methodologies</li>
<li>Risk mitigation strategies for seamless migration</li>
<li>Change management best practices for user adoption success</li>
<li>Performance measurement and ROI realization strategies</li>
    </ul>
    `,
    idForm: 'DownloadtheGuideThePathForwardStrategicImplementat/formperma/Qrq6q5m_DKcwLusseUiepTq5z6v5yqIXVF4pD02LevA',
  },
];
export default guideAndReportsItems;
